import { ReactNode, useContext, useEffect, useMemo } from "react";
import { AppMainStateContext } from "../../contexts/AppMainStateContext";
import Notification from "../notification/Notification";
import { useNotification } from "../../providers/NotificationProvider.tsx";
import { useLocation, useNavigate } from "react-router-dom";
import UtilsHelper from "../../helpers/utilsHelper.ts";

const RootLayout = ({ children }: { children: ReactNode }) => {
    const _location = useLocation();
    const _navigate = useNavigate();
    const isMaintenanceMode = import.meta.env.VITE_IS_MAINTENANCE_MODE === "true";
    const { closeModal } =
        useContext(AppMainStateContext);
    const { isNotificationVisible } = useNotification();

    useEffect(() => {
        closeModal();
        const htmlElem = document.querySelector('html');
        htmlElem?.scrollTo({ top: 0, behavior: 'instant' });
    }, [_location]);

    useEffect(() => {
        if (isMaintenanceMode && _location.pathname !== "/przerwa-technicza") {
            UtilsHelper.changeWindowDocumentTitle("Przerwa techniczna");
            _navigate("/przerwa-technicza");
        }
    }, [isMaintenanceMode, _location, _navigate])


    const notification = useMemo(() => <Notification />, []);

    return (
        <>
            {children}
            {isNotificationVisible ? notification : null}
        </>
    );
};

export default RootLayout;